import { render, staticRenderFns } from "./AboutVisit.vue?vue&type=template&id=5d6cf3eb&"
import script from "./AboutVisit.vue?vue&type=script&lang=js&"
export * from "./AboutVisit.vue?vue&type=script&lang=js&"
import style0 from "./AboutVisit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports